"use strict";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(generator);

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
/**
 * Fibonacci
 *
 * Produces an Fibonacci number sequence. In Fibonacci number
 * sequences, each number is the sum of the two preceding
 * ones, starting from 0 and 1.
 */
// Public API
exports.default = function () {
  return (0, immutable_1.Seq)(generator());
};
// Generator
function generator() {
  var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return regeneratorRuntime.wrap(function generator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return current;

        case 2:
          return _context.delegateYield(generator(next, current + next), "t0", 3);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}
//# sourceMappingURL=fibonacci.js.map


//////////////////
// WEBPACK FOOTER
// ./client/vendor/number-sequences/dist/fibonacci.js
// module id = 275
// module chunks = 0